import React from 'react';
import { CalendarClock, AlertCircle } from 'lucide-react';

const ScheduleAppointment = () => {
  return (
    <div className="min-h-[70vh] flex items-center justify-center p-4">
      <div className="bg-white rounded-[32px] shadow-xl shadow-slate-200/40 border border-slate-100 p-8 sm:p-12 max-w-xl w-full text-center space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-300">
        <div className="w-24 h-24 bg-indigo-50 rounded-[36px] mx-auto flex items-center justify-center shadow-lg shadow-indigo-100/50">
          <CalendarClock className="w-12 h-12 text-[#143E78]" />
        </div>

        <div className="space-y-2">
          <h2 className="text-2xl font-black text-slate-800 tracking-tight">Schedule an Appointment</h2>
          <p className="text-sm font-bold text-slate-400 max-w-sm mx-auto leading-relaxed">
            This module is currently under development. Appointment scheduling workflows and calendar integrations will be available soon.
          </p>
        </div>

        <div className="bg-indigo-50/50 border border-indigo-100 rounded-2xl p-4 flex items-start gap-3 text-left">
          <AlertCircle className="w-5 h-5 text-indigo-600 shrink-0 mt-0.5" />
          <div>
            <h4 className="text-xs font-black text-indigo-950 uppercase tracking-wider">Note for CC & Admins</h4>
            <p className="text-[11px] font-bold text-indigo-600/90 mt-0.5">
              Incoming patient registrations can still be processed through Lead Management.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScheduleAppointment;
